import React, { Component } from 'react';
import { MsalAuthProvider, LoginType } from 'react-aad-msal';
//import "core-js/stable";
import "regenerator-runtime/runtime";

export const msalConfig = {
    auth: {
        authority: 'https://login.microsoftonline.com/e202cd47-7a56-4baa-99e3-e3b71a7c77dd',
        clientId: 'f72cdd12-6339-44b3-b1ca-7f14e8b58d8f',
        redirectUri: 'https://apps.sa.uic.edu/geer'
        //redirectUri: 'https://dev.sa.uic.edu/geer'
        //redirectUri: 'https://localhost:44391'
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: true
    }
}

export const loginRequest = {
    scopes: ["user.read"]
}

const options = {
    loginType: LoginType.Redirect
}
